var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecentTrendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.31166 0.125L14.9771 0.12539L15.0522 0.13583L15.1263 0.156537L15.1716 0.1757C15.231 0.201845 15.2867 0.239862 15.3356 0.28877L15.3661 0.3218L15.3987 0.364085L15.4394 0.431675L15.4684 0.499415L15.4827 0.547475L15.4929 0.595475L15.5 0.666125L15.5004 6.31542C15.5004 6.62607 15.2485 6.87792 14.9379 6.87792C14.6531 6.87792 14.4177 6.66627 14.3805 6.39177L14.3754 6.31542L14.375 2.04425L8.58588 7.83447C8.38616 8.03412 8.07371 8.05235 7.85343 7.88893L7.79036 7.83447L5.5625 5.60668L1.46024 9.70895C1.24058 9.92863 0.884424 9.92863 0.664749 9.70895C0.465054 9.50923 0.446897 9.19677 0.610292 8.97657L0.664749 8.91342L5.16475 4.41343C5.36445 4.21378 5.67694 4.19562 5.89715 4.35897L5.96024 4.41343L8.18808 6.64122L13.5785 1.25L9.31166 1.25C9.02688 1.25 8.79161 1.03839 8.75433 0.763827L8.74916 0.6875C8.74916 0.402725 8.96081 0.167382 9.23538 0.130137L9.31166 0.125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentTrendIcon);
export default __webpack_public_path__ + "static/media/recent-trend-icon.71bbb69f609879aeaa7b6016810e7c61.svg";
export { ForwardRef as ReactComponent };